import _slicedToArray from "/Users/kenny.lienhard/Documents/dev_gatsby/tmstrainer/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import has from 'lodash/has'; // @ts-expect-error

import toposort from 'toposort';
import { split } from 'property-expr';
import Ref from '../Reference';
import isSchema from './isSchema';
export default function sortFields(fields) {
  var excludedEdges = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var edges = [];
  var nodes = new Set();
  var excludes = new Set(excludedEdges.map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        a = _ref2[0],
        b = _ref2[1];

    return "".concat(a, "-").concat(b);
  }));

  function addNode(depPath, key) {
    var node = split(depPath)[0];
    nodes.add(node);
    if (!excludes.has("".concat(key, "-").concat(node))) edges.push([key, node]);
  }

  var _loop = function _loop(key) {
    if (has(fields, key)) {
      var value = fields[key];
      nodes.add(key);
      if (Ref.isRef(value) && value.isSibling) addNode(value.path, key);else if (isSchema(value) && 'deps' in value) value.deps.forEach(function (path) {
        return addNode(path, key);
      });
    }
  };

  for (var key in fields) {
    _loop(key);
  }

  return toposort.array(Array.from(nodes), edges).reverse();
}